import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import ErrorMessage from "@Components/ErrorMessage";

import { Field } from "formik";
import "date-fns";
import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { InputLabel } from "@material-ui/core";
import { format } from "date-fns";
import { useFormikContext } from "formik";

import useStyles from "assets/jss/material-dashboard-react/components/customDatepickerStyle";

const DatePicker = (props) => {
  const {
    name,
    label,
    required,
    errorMessage,
    emptyLabel, // Use the emptyLabel prop for the placeholder
    maxDate,
    minDate,
    getValue,
    ...rest
  } = props;
  const formik = useFormikContext();

  const classes = useStyles();
  const handleChange = (event) => {
    if (event) {
      getValue ? getValue(format(event.toDate(), "yyyy-MM-dd")) : null;
      formik.setFieldValue(name, format(event.toDate(), "yyyy-MM-dd"));
    } else {
      getValue ? getValue(null) : null;
      formik.setFieldValue(name, null);
    }
  };
  return (
    <Field name={name}>
      {(props) => {
        const { field, meta } = props;
        const { value } = field;
        return (
          <>
            <InputLabel
              htmlFor={name}
              className={clsx(classes.label, {
                [classes.error]: errorMessage || (meta.error && meta.touched),
              })}
            >
              {label}
              {required ? <span style={{ color: "red" }}> *</span> : null}
            </InputLabel>

            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                fullWidth
                inputVariant="outlined"
                className={classes.root}
                id={name}
                format="DD/MM/YYYY"
                maxDate={maxDate || new Date("2100-01-01")}
                minDate={minDate || new Date("1990-01-01")}
                emptyLabel={emptyLabel ? emptyLabel : "DD/MM/YYYY"} // Use the emptyLabel prop here
                value={value}
                allowKeyboardControl={false}
                onKeyDown={(e) => e.preventDefault()}
                onChange={(value) => handleChange(value)}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                DialogProps={{ className: classes.dialogStyle }}
                InputProps={{ className: !value ? classes.emptyLabel : null }}
                {...rest}
              />
            </MuiPickersUtilsProvider>
            {errorMessage || (meta.error && meta.touched) ? (
              <ErrorMessage
                message={errorMessage ? errorMessage : meta.error}
              />
            ) : null}
          </>
        );
      }}
    </Field>
  );
};

DatePicker.propTypes = {
  name: PropTypes.string,
  emptyLabel: PropTypes.string,
  label: PropTypes.string,
  field: PropTypes.object,
  meta: PropTypes.object,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  maxDate: PropTypes.Date,
  minDate: PropTypes.Date,
  getValue: PropTypes.func,
};

export default DatePicker;